import { deliveryGeographyKey, normalizeDeliveryGeography } from '../api/client';

/**
 * The geography Checkout prices, stocks and schedules for: the delivery
 * address's own pincode and pinned coordinates — never the browsing location,
 * never a display string, never an outlet.
 *
 * Both are required. Order placement refuses an address without a pincode or
 * without coordinates (DELIVERY_COORDINATES_REQUIRED) and resolves the serving
 * outlet from exactly those two values, so Checkout quotes the same geography
 * placement will use — or nothing at all.
 *
 *   { geography, key, problem }
 *   geography  { pincode, coordinates } for per-request pinning, or null
 *   key        stable identity of that geography ('' when none)
 *   problem    null | 'no_address' | 'pincode_missing' | 'coordinates_missing'
 */
export const checkoutGeographyFor = (address) => {
  if (!address) return { geography: null, key: '', problem: 'no_address' };
  const normalized = normalizeDeliveryGeography({ pincode: address.pincode, coordinates: address.coordinates });
  if (!normalized?.pincode) return { geography: null, key: '', problem: 'pincode_missing' };
  if (!normalized.coordinates) return { geography: null, key: '', problem: 'coordinates_missing' };
  return { geography: normalized, key: deliveryGeographyKey(normalized), problem: null };
};
